<form class="example-form">
    <mat-checkbox [formControl]="checkboxFormControl"></mat-checkbox>
</form>
